import $ from "jquery";
import { transformWindowCoordinateToCanvasCoord } from './calc'
import startImage from "../../assets/img/ic_pin_mapa.png"
import endImage from "../../assets/img/ic_ubicacion_actual.png"
import stairsImage from "../../assets/img/ic_escalera.png"

export const drawStartIcon = (x, y, w, h, zIndex, title, floor, screenWidth) => {
 draw(x, y, w, h, startImage, 'startIcon', 'start-image', zIndex, title, floor, screenWidth)
}

export const removeStartIcon = () => {
  removeAll('startIcon');
}

export const drawEndIcon = (x, y, w, h, zIndex, title, floor, screenWidth) => {
  draw(x, y, w, h, endImage, 'endIcon', 'end-image', zIndex, title, floor, screenWidth)
}

export const removeEndIcon = () => {
  removeAll('endIcon');
}

export const drawStairsIcon = (x, y, w, h, zIndex, title, floor, screenWidth) => {
  draw(x, y, w, h, stairsImage, 'stairsIcon', 'start-image', zIndex, title, floor, screenWidth)
}

export const removeStairsIcon = () => {
  removeAll('stairsIcon');
}

export const drawServiceIcon = (x, y, w, h, icon, zIndex, title, floor, screenWidth) => {
  draw(x, y, w, h, icon, 'serviceIcon', 'start-image', zIndex, title, floor, screenWidth);
}

export const removeServiceIcon = () => {
  removeAll('serviceIcon');
}

// Se pueden dibujar varios íconos con el mismo id (p.ej. dos escaleras) y
// $('#id') solo encuentra el primero, así que se borran todos por atributo.
function removeAll(id) {
  $(`#iconsContainer [id="${id}"]`).remove();
}

function draw(x, y, w, h, image, id, cssClass, zIndex = 150, title = '', floor, screenWidth) {
  let trans = transformWindowCoordinateToCanvasCoord(x, y, w, h, floor, screenWidth);
  let tooltip = '';
  if (title) {
    tooltip = `<span style="
      position: absolute;
      top: ${id === 'endIcon' ? -45 : -70}px;
      left: 50%;
      transform: translateX(-50%);
      background: #ffffff;
      color: #e6144f;
      padding: 4px 8px;
      border: 1px solid #e6144f;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      z-index: ${zIndex + 1};
      pointer-events: none;
      ">${title}</span>`;
  }
  $('#iconsContainer').prepend(
    `<div id="${id}" style="position: absolute; top:${trans.y}px; left:${trans.x}px; z-index:${zIndex};">
      <img src="${image}" class="canvas-anim-img ${cssClass}" style="z-index: ${zIndex};"/>
      ${tooltip}
    </div>`
  );
}


// WEBPACK FOOTER //
// ./src/utils/cssAnimator.js